import { TRemindersApiResponseObject } from "../types/reminder-types.types";
import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptedRequest } from "../core/api.client";

export const getReminders = async () => {
  try {
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);

    const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");

    const { custId } = await getSessionData();

    if (mobileNo) {
      const encReq = {
        mobileNo,
        customerId: custId,
      };

      const response: TRemindersApiResponseObject = await encryptedRequest({
        method: "POST",
        url: API_PATHS.reminders,
        data: encReq,
      });

      if (response.statusCode !== 90) {
        throw response.message;
      }

      return response;
    }
  } catch {}
};
